module.exports = __webpack_public_path__ + "static/assets/jake-blucker-ZGnC2gOvzKw-unsplash.d9942c8c.jpg";